import css from 'styled-jsx/css'

export const CheckboxStyle = css`
.custom-control {
    position: relative;
}
.custom-control > input {
    position: absolute;
    top: 0.4em;
    left: 0;
    z-index: 2;
    cursor: pointer;
}
.custom-control-label {
  line-height: 22px;
  vertical-align: top;
}
`
